export const formatTableText = (text) => {
  if (text === null || text === undefined) return 'N/A'
  
  const textString = String(text)
  
  if (textString.trim() === '') return 'N/A'
  
  return textString.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())
}